import React from 'react';
import { Route, Switch } from 'react-router';
import { LevendeKontrakter } from '@klp/levendekontrakter/views/LevendeKontrakter';
import { ContractRegistrationListView } from '@klp/contractregistration';
import {
    ContractManagementRegistrationAccess,
    ContractManagementRoutes,
    ContractManagementTabs,
} from '@forvalter/routing/Routes';

export const ContractManagementContent: React.FC = () => {
    return (
        <Switch>
            <Route
                path={ContractManagementRoutes.tab(
                    ContractManagementTabs.levendekontrakter,
                )}
            >
                <LevendeKontrakter />
            </Route>
            {ContractManagementRegistrationAccess() && (
                <Route
                    path={ContractManagementRoutes.tab(
                        ContractManagementTabs.registrering,
                    )}
                >
                    <ContractRegistrationListView />
                </Route>
            )}
        </Switch>
    );
};
